module.exports = __webpack_public_path__ + "static/img/ddz-barnner.a6d0082c.jpg";